export default "__VITE_ASSET__CMjLoWGQ__"